import { gql } from "apollo-boost"

export const GET_ACTIVITIES_BY_SUBMISSION = gql`
  query activitiesBySubmissionId ($id: ID!) {
    activitiesBySubmissionId (id: $id) {
      id
      description
      title
      orderIndex
    }
  }
`